export const common = {
  nav: {
    home: '홈',
    about: '소개',
    training: '훈련',
    give: '후원',
    contact: '문의',
  },
  hero: {
    title: '다음 세대를 세우다',
    subtitle: '진정한 예배와 하나님의 임재를 통해 세상을 변화시킬 예배자와 리더를 양성합니다',
    watchBtn: '시청하기',
    joinBtn: 'AID 참여하기',
  },
  about: {
    badge: '소개',
    title: '예배자와 리더를 세우다',
    intro: 'AID Worship은 "Amen in the Dark(어둠 속의 아멘)"를 의미합니다. 우리는 어두운 세상에서 아멘을 선택하고, 주님을 예배하며 그분과 함께 신실하게 걷는 예술적 가족입니다.',
    paragraph1: '우리는 다음 세대가 하나님의 임재 안에서 성장하고, 그들의 세대에 영향을 미치는 예배자와 리더가 되도록 돕습니다. 예배 중심의 모임을 통해 사람들을 하나님과의 더 깊은 만남으로 인도합니다.',
    paragraph2: '다음 세대 사역을 통해 개인이 하나님께서 주신 정체성, 은사, 부르심을 발견하도록 돕고, 그들의 창의성, 음악적 능력, 리더십 잠재력, 영적 은사를 사용하도록 격려합니다.',
    paragraph3: '예배 콘텐츠(곡, 편곡, 녹음, 미디어)를 만들어가며 음악적 기술을 개발하고, 그들이 목적을 가지고 은사를 관리하며 예배를 통해 믿음을 표현하도록 돕습니다.',
    paragraph4: '멘토링과 훈련을 통해 그들과 함께 걸으며, 하나님의 임재 안에서 강하게 성장하고, 말씀에 뿌리내리며, 부르심에 확신을 갖도록 돕습니다.',
    learnMoreBtn: '우리의 사명 더 알아보기',
  },
  training: {
    badge: '훈련',
    title: '예배자와 리더를 준비시키다',
    subtitle: '하나님의 임재를 경험하고 열방을 변화시킬 예배자와 리더를 양성하는 제자훈련 프로그램',
    program1Title: '예배 리더 훈련',
    program1Desc: '예배 리더로서 부르심과 기술을 모두 개발하는 전문 훈련',
    program2Title: '성경적 기초',
    program2Desc: '성경적 기반 위에서 예배의 본질과 신학을 깊이 배웁니다',
    program3Title: '예배 콘텐츠 제작',
    program3Desc: '음악과 창의성을 통해 예배 콘텐츠를 만들어갑니다',
    program4Title: '영적 형성',
    program4Desc: '하나님과의 친밀한 관계 속에서 영적 성숙의 여정을 걷습니다',
    comingSoonTitle: '2026년 훈련 프로그램 준비 중',
    comingSoonSubtitle: '다음 세대 예배자와 리더를 양성하는 여정에 함께하세요',
    comingSoonBtn: '준비 중',
  },
  give: {
    badge: '후원',
    title: '우리의 여정에 함께하세요',
    subtitle: '여러분의 후원이 세상을 변화시킬 다음 세대 예배자와 리더를 양성하는 데 도움이 됩니다',
    impactArea1Title: '청소년 사역',
    impactArea1Desc: '청소년과 10대 사역을 위한 프로그램과 자원을 제공합니다',
    impactArea2Title: '리더십 훈련',
    impactArea2Desc: '다음 세대 예배 리더를 양성하는 교육 과정을 운영합니다',
    impactArea3Title: '선교 사역',
    impactArea3Desc: '지역사회를 섬기는 선교 활동을 진행합니다',
    donateBtn: '후원하기',
    partnerBtn: '파트너 되기',
    impactNote: '여러분의 후원금 100%가 직접 사역에 사용됩니다',
    impactNoteDesc: '모든 후원금은 투명하게 사역을 위해 사용됩니다',
    modalTitle: '후원하기',
    selectAmount: '금액 선택 (USD)',
    customAmount: '직접 입력',
    donorName: '이름 (선택)',
    donorNamePlaceholder: '이름을 입력하세요',
    donorEmail: '이메일 *',
    donorEmailPlaceholder: 'your@email.com',
    message: '메시지 (선택)',
    messagePlaceholder: '메시지를 남겨주세요...',
    donateButton: '후원하기 $',
    processing: '처리 중...',
    paypalNote: '후원금은 페이팔을 통해 안전하게 처리됩니다',
    successTitle: '후원해 주셔서 감사합니다!',
    successMessage: '여러분의 후원이 큰 힘이 됩니다',
  },
  contact: {
    badge: '문의',
    title: '연락하기',
    subtitle: '궁금한 점이나 더 알고 싶으신가요? 언제든지 문의해 주세요',
    namePlaceholder: '이름',
    emailPlaceholder: '이메일',
    messagePlaceholder: '메시지',
    sendBtn: '메시지 보내기',
    sending: '전송 중...',
    success: '메시지가 성공적으로 전송되었습니다!',
    error: '메시지 전송에 실패했습니다. 다시 시도해 주세요.',
  },
  footer: {
    description: '진정한 예배와 하나님의 임재를 통해 세상을 변화시킬 예배자와 리더를 양성합니다',
    quickLinks: '바로가기',
    connect: '연결',
    rights: '모든 권리 보유',
  },
};